export const getLastFrameAttributes = (stripsItem) => {
  const template = stripsItem?.template;

  const lastItem = stripsItem?.children?.length
    ? stripsItem.children[stripsItem.children.length - 1]
    : null;

  let stripsItemHeadline;
  let stripsItemSubline;
  let stripsItemButton;

  if (template === 'StripsTemplateWithPlainImages') {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_image, wrapper, button] = lastItem?.children || [];
    const [headline, subline] = wrapper?.children || [];

    stripsItemHeadline = headline;
    stripsItemSubline = subline;
    stripsItemButton = button;
  } else {
    const [
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      _image,
      headline,
      subline,
      button,
    ] = lastItem?.children || [];

    stripsItemHeadline = headline;
    stripsItemSubline = subline;
    stripsItemButton = button;
  }

  const headlineAttributesToApply = stripsItemHeadline?.attributes;
  const sublineAttributesToApply = stripsItemSubline?.attributes;
  const buttonAttributesToApply = stripsItemButton?.attributes;

  return {
    headlineAttributesToApply,
    sublineAttributesToApply,
    buttonAttributesToApply,
  };
};
